import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
import { colours as colourOverrides, typography } from '@domain-group/fe-co-allhomes-design-system';
import { actionButton, partialColumn, subheading } from './inspections-auctions.style';
var headingM = typography.headingM,
  body = typography.body;
export var button = /*#__PURE__*/css(actionButton, ";");
export var onlineHeading = /*#__PURE__*/css(subheading, ";");
export var goOnline = /*#__PURE__*/css("display:block;", media('>=desktop'), "{display:inline;}");
export var onlineCard = {
  name: "178yklu",
  styles: "margin-top:24px;"
};
export var onlineText = {
  name: "1qm1lh",
  styles: "margin-bottom:16px;"
};
export var details = /*#__PURE__*/css(partialColumn, ";display:flex;align-items:center;margin-bottom:16px;");
export var icon = /*#__PURE__*/css("color:", colourOverrides.textLight, ";margin-right:10px;");
export var text = /*#__PURE__*/css("color:", colourOverrides.text, ";flex-grow:1;");
export var cardTitle = /*#__PURE__*/css(headingM, ";margin-bottom:8px;");
export var cardMessage = /*#__PURE__*/css(body, ";");